import { memo } from "react";

import { StaticMainHeader } from "~/components/MainHeader/StaticMainHeader";

import "./PreviewAppHeader.css";

/**
 * Preview face of the shared `<StaticMainHeader>` replica — see that
 * component for why the app header is replicated rather than reused.
 *
 * Unlike the print face this one KEEPS `MainHeader`'s sticky positioning
 * (no `position: static` override): the preview scrolls like the live app,
 * and the header staying put while the form scrolls under it is part of the
 * screen being replicated.
 *
 * Memoized with no props: the previewed form re-renders `PreviewForm` on
 * every keystroke, and this subtree never changes.
 */
export const PreviewAppHeader = memo(function PreviewAppHeader() {
    return (
        <StaticMainHeader
            className="preview-app-header"
            testId="preview-app-header"
        />
    );
});
